const env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV

const API_BASE_URL_LIST = {
  "development":  "https://pzj5ji42gb.execute-api.ap-northeast-1.amazonaws.com/api",
  "staging":     "https://xexcoshs82.execute-api.ap-northeast-1.amazonaws.com/api",
  "production": "https://ny43l5e4pe.execute-api.ap-northeast-1.amazonaws.com/api"
}
const API_BASE_URL = API_BASE_URL_LIST[env_key]

const API_ID = "Niico"
const SITE_TITLE = env_key === "production" ? "にいがたチョイnavi：JR東日本" : "【STG】にいがたチョイnavi：JR東日本";
const API_MIXWAY_PATH = "https://mixway.ekispert.jp/v1/json/"
const AVAILABLE_LANGUAGES = ['ja', 'en', 'zh-TW']
const ENABLED_DOCOMO_MOBAKU = true
// このエリアを検索のボタン表示
const ENABLED_MAP_SEARCH_PLACE = false
// 名称検索時に表示するPOIの最大数
const MAX_SEARCH_PLACE = 20
// 保存可能な施設数
const MAX_FAVORITE_PLACE = 20

const JREAST_APP_SCHEMA = "https://jreastapp.page.link"
const JREAST_PC_SITE = "https://play.google.com/store/apps/details?id=jp.co.jreast&hl=ja"
const MIXWAY_URL = "https://mixway.ekispert.net"

// 中心となる駅
const DEFAULT_STATION_LOCATION = {
  latitude: 36.3831839,
  longitude: 139.0710233
}

const DEFAULT_MY_LOCATION_RADIUS = 30

const LINK_BASE_URL_LIST = {
  "development": "https://dev.g3m.jp",
  "staging": "https://stg.g3m.jp",
  "production": "https://g3m.jp"
}
const LINK_BASE_URL = LINK_BASE_URL_LIST[env_key]

const REAL_TIME_SEARCH_WEB_LIST = {
  "development": "https://transit-stg.jre-maas.com/",
  "staging": "https://transit-stg.jre-maas.com/",
  "production": "https://transit.jre-maas.com/"
}
const REAL_TIME_SEARCH_WEB = REAL_TIME_SEARCH_WEB_LIST[env_key]

const BUS_LOCATION_API_URL_LIST = {
  "development": "https://ywshuoyn6e.execute-api.ap-northeast-1.amazonaws.com/staging/",
  "staging": "https://ywshuoyn6e.execute-api.ap-northeast-1.amazonaws.com/staging/",
  "production": "https://vnsz7ye4g7.execute-api.ap-northeast-1.amazonaws.com/production/"
}
const BUS_LOCATION_API_URL = BUS_LOCATION_API_URL_LIST[env_key]
const BUS_LOCATION_API_KEY_LIST = {
  "development": "t9Ito87ogs8t5mQu2Tj7maSw1W04I1TdaCO14Xdy",
  "staging": "t9Ito87ogs8t5mQu2Tj7maSw1W04I1TdaCO14Xdy",
  "production": "IbmG6IUnVU2PNABxedWOD7EZ8k2DsDzw2NkTUkXu"
}
const BUS_LOCATION_API_KEY = BUS_LOCATION_API_KEY_LIST[env_key]
const BUS_LOCATION_TRIP_COUNT = 3

const DEMAND_LINK_URL_LIST = {
  "development": "https://tour.jre-maas.com/maemaas-demand-stg/#/ja/",
  "staging": "https://tour.jre-maas.com/maemaas-demand-stg/#/ja/",
  "production": "https://tour.jre-maas.com/maemaas-demand/#/ja/"
}
const DEMAND_LINK_URL = DEMAND_LINK_URL_LIST[env_key]

const TAXI_LINK_URL_LIST = {
  "development": "https://tour.jre-maas.com/maemaas-taxi-stg/#/ja/",
  "staging": "https://tour.jre-maas.com/maemaas-taxi-stg/#/ja/",
  "production": "https://tour.jre-maas.com/maemaas-taxi/#/ja/"
}
const TAXI_LINK_URL = TAXI_LINK_URL_LIST[env_key]

export default {
  API_ID: API_ID,
  SITE_TITLE: SITE_TITLE,
  API_MIXWAY_PATH: API_MIXWAY_PATH,
  AVAILABLE_LANGUAGES: AVAILABLE_LANGUAGES,
  ENABLED_DOCOMO_MOBAKU: ENABLED_DOCOMO_MOBAKU,
  ENABLED_MAP_SEARCH_PLACE: ENABLED_MAP_SEARCH_PLACE,
  MAX_SEARCH_PLACE: MAX_SEARCH_PLACE,
  MAX_FAVORITE_PLACE: MAX_FAVORITE_PLACE,
  DEFAULT_STATION_LOCATION: DEFAULT_STATION_LOCATION,
  DEFAULT_MY_LOCATION_RADIUS: DEFAULT_MY_LOCATION_RADIUS,
  JREAST_APP_SCHEMA: JREAST_APP_SCHEMA,
  JREAST_PC_SITE: JREAST_PC_SITE,
  MIXWAY_URL: MIXWAY_URL,
  REAL_TIME_SEARCH_WEB: REAL_TIME_SEARCH_WEB,
  LINK_BASE_URL: LINK_BASE_URL,
  API_BASE_URL: API_BASE_URL,
  BUS_LOCATION_API_URL: BUS_LOCATION_API_URL,
  BUS_LOCATION_API_KEY: BUS_LOCATION_API_KEY,
  BUS_LOCATION_TRIP_COUNT: BUS_LOCATION_TRIP_COUNT,
  DEMAND_LINK_URL: DEMAND_LINK_URL,
  TAXI_LINK_URL: TAXI_LINK_URL
}